export enum LayoutsEnum {
  default = 'DEFAULT',
  basic = 'BASIC',
  secured = 'SECURED',
  tradingPlatform = 'TRADING_PLATFORM',
}
